import { API } from 'aws-amplify';
import { authHeader } from 'utils/auth';

export async function getHRISDataInsights(reportId: string): Promise<{
  missingRaceEthnicity: number;
  missingWorkLocation: number;
  missingSexCategory: number;
  missingRequiredField: number;
} | null> {
  const apiName = 'hrisDataAPI';
  const path = `/report/${reportId}/hris-data/data-insights`;
  const headers = await authHeader();
  try {
    return await API.get(apiName, path, {
      headers
    });
  } catch (error) {
    console.log('Error: ', error);
    return null;
  }
}

export async function resyncData(reportId: string): Promise<boolean> {
  const apiName = 'hrisDataAPI';
  const path = `/report/${reportId}/hris-data/resync`;
  const headers = await authHeader();
  try {
    await API.post(apiName, path, {
      headers
    });
    return true;
  } catch (error) {
    console.log('Error: ', error);
    return false;
  }
}
